var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('countdown',{attrs:{"time":_vm.time},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var minutes = ref.minutes;
var seconds = ref.seconds;
return [_vm._t("default",null,{"minutes":minutes,"seconds":seconds})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }